// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-fNLWwk{align-items:center;display:flex}.header-fNLWwk .name-lkeX91{flex:1}.header-fNLWwk .type-PVzaBb{flex-grow:0;flex-shrink:0;width:155px;margin-left:8px}.header-fNLWwk .description-wOrxF3{width:312px;margin-left:8px}.header-fNLWwk.withDescription-wSH9rA .name-lkeX91{flex:none;width:181px}.text-hRzSet{color:var(--light-usage-text-color-text-3,rgba(28,31,35,.35));font-size:10px;font-style:normal;font-weight:400;line-height:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `header-fNLWwk`,
	"name": `name-lkeX91`,
	"type": `type-PVzaBb`,
	"description": `description-wOrxF3`,
	"withDescription": `withDescription-wSH9rA`,
	"text": `text-hRzSet`
};
export default ___CSS_LOADER_EXPORT___;
